import React, { useEffect, useRef, useState } from "react";

const YouTubeBackground = ({ videoId, widthPercent }) => {
  const iframeRef = useRef(null);
  const [height, setHeight] = useState(0);
  const [widthInPixels, setWidthInPixels] = useState(0);

  useEffect(() => {
    const resizeIframe = () => {
      const windowWidth = window.innerWidth; // Ottieni la larghezza della finestra
      const calculatedWidth = (windowWidth * widthPercent) / 100; // Calcola la larghezza in pixel
      setWidthInPixels(calculatedWidth);

      const newHeight = (calculatedWidth * 9) / 16; // Calcola l'altezza mantenendo il rapporto 16:9
      setHeight(newHeight);
    };

    resizeIframe(); // Calcola la larghezza e altezza iniziali
    window.addEventListener("resize", resizeIframe); // Ricalcola su ridimensionamento
    return () => window.removeEventListener("resize", resizeIframe); // Pulizia dell'evento
  }, [widthPercent]); // Ricalcola solo quando cambia la percentuale della larghezza

  return (
    <iframe
      ref={iframeRef}
      src={`https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&controls=0&modestbranding=1&rel=0&iv_load_policy=3&disablekb=1&fs=0&cc_load_policy=0&playsinline=1&showinfo=0&origin=http://localhost&start=1`}
      frameBorder="0"
      allow="autoplay; encrypted-media"
      allowFullScreen
      style={{
        pointerEvents: "none",
        width: `${widthPercent}%`, // Imposta la larghezza dinamica calcolata
        //height: `${height}px`, // Imposta l'altezza dinamica
      }}
    ></iframe>
  );
};

export default YouTubeBackground;
